module.exports = __webpack_public_path__ + "static/media/DEENCONNECT_MasjidBaitusSalam_12.89349230.jpeg";